module.exports = __webpack_public_path__ + "img/14.e318fb05.jpg";